import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UiPasswordIndicatorModule } from '@components/ui-password-indicator/ui-password-indicator.module';
import { UiPasswordTypeToggleModule } from '@components/ui-password-toggle/ui-password-toggle.module';
import { UiThemePreviewModule } from '@components/ui-theme-preview/ui-theme-preview.module';
import { SharedModule } from '@modules/shared.module';
import { ProfilePageComponent } from '@pages/profile/profile.page';
import { UiUserProfileGeneralComponent } from '@pages/profile/user-profile-general.component';
import { UiUserProfileNotificationsComponent } from '@pages/profile/user-profile-notifications.component';
import { UiUserProfileSecurityComponent } from '@pages/profile/user-profile-security.component';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { UiLoginAttemptsGridModule } from '../shared/grids/login-attempts';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiPasswordTypeToggleModule,
        UiPasswordIndicatorModule,
        UiSuggestModule,
        UiThemePreviewModule,
        UiLoginAttemptsGridModule,
        UiSpinnerButtonModule,
        MatProgressSpinnerModule,
    ],
    declarations: [
        ProfilePageComponent,
        UiUserProfileGeneralComponent,
        UiUserProfileSecurityComponent,
        UiUserProfileNotificationsComponent,
    ],
    exports: [
        ProfilePageComponent,
    ],
})
export class ProfileModule { }
